/* eslint-disable array-bracket-newline */
import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AutoSizer } from 'react-virtualized';
import { ITicker, enums } from '@kattana-io/common';
import TickersModalTable from './Table';
import { IStore } from '../../../../reducers';
import { ITableSort } from '../../../../molecules/Table/DesktopTable';
import { switchCurrentTicker } from '../../../../Authlogic';
import { actionCloseModal } from '../../../../actions/modal';
import {
  actionTickersNextPageModal,
  actionUpdateModalParams,
} from '../../../../actions/modal_search';

/**
 * Implements a table with trades
 * @param param0
 */
const TickersModalDataLayer = () => {
  const [tableSort, setTableSort] = useState<ITableSort>({
    id: 'liquidity',
    isSortedDesc: true,
  });
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const rates = useSelector((state: IStore) => state.rates.items);
  const currentId = useSelector((state: IStore) => state.current.id);
  const {
    search,
    exchanges,
    tickers,
    loading,
    isNextPageLoading,
    kind,
    chains,
  } = useSelector((state: IStore) => state.modal_search, shallowEqual);

  const dispatch = useDispatch();

  const handleSort = useCallback(
    (id: string) => {
      if (tableSort.id === id) {
        setTableSort({ id, isSortedDesc: !tableSort.isSortedDesc });
      } else {
        setTableSort({ id, isSortedDesc: true });
      }
    },
    [tableSort.id, tableSort.isSortedDesc]
  );

  /**
   * On ticker clicked
   * @param item
   */
  const onTickerClick = useCallback(
    (data: ITicker) => {
      switchCurrentTicker(data);
      dispatch(actionCloseModal());
    },
    [dispatch]
  );

  /**
   * load next page
   */
  const onLoadNextPage = useCallback(() => {
    dispatch(
      actionTickersNextPageModal({
        exchanges: exchanges,
        chains: chains,
        search: search,
      })
    );
  }, [chains, dispatch, exchanges, search]);

  useEffect(() => {
    if (
      (!chains.length && exchanges.length) ||
      kind === enums.ETickerKind.CEX
    ) {
      setTableSort({ id: 'volume', isSortedDesc: true });
      setHiddenColumns([
        'liquidity',
        'contract',
        'annual_percentage_yield',
        'chain',
      ]);
    } else {
      setTableSort({ id: 'liquidity', isSortedDesc: true });
      setHiddenColumns([]);
    }
  }, [exchanges, chains, kind]);

  useEffect(() => {
    dispatch(
      actionUpdateModalParams({
        sort: {
          name: tableSort.id,
          order: tableSort.isSortedDesc ? 'DESC' : 'ASC',
        },
      })
    );
  }, [tableSort]);

  return (
    <AutoSizer style={{ width: '100%', height: '100%' }}>
      {({ width }) => (
        <TickersModalTable
          rates={rates}
          currentId={currentId}
          tickers={tickers}
          loading={loading}
          hiddenColumns={hiddenColumns}
          isNextPageLoading={isNextPageLoading}
          width={width}
          tableSort={tableSort}
          onTickerClick={onTickerClick}
          handleSort={handleSort}
          onLoadNextPage={onLoadNextPage}
        />
      )}
    </AutoSizer>
  );
};

export default TickersModalDataLayer;
